/*
 * Copyright (c) Nexign, JSC, 2020-2021.
 */
/**
 * Tariffs And Services Side Search Styled
 *
 * @author Aleksandr Perkhunov
 * @author Yakov Gushchin
 * @version 1.10.0
 * @since 1.4.0
 */

import styled from 'styled-components';

import { colors } from '../../../../theme';

export const TariffsAndServicesSideSearchStyled = styled.div`
    border-bottom: 1px solid ${colors.tariffsAndServicesSideBordersColor};
    border-left: 1px solid transparent;

    position: relative;

    .input__input-block,
    .input__input-block:focus {
        border: none;
        color: rgba(51, 51, 51, 0.5);
    }
`;

export const TariffsAndServicesSideSearchFoundStyled = styled.div`
    position: absolute;
    width: 250px;
    top: 40px;
    left: 32px;
    background: white;

    box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);
`;

export const TariffsAndServicesSideSearchFoundItemStyled = styled.div`
    color: rgba(51, 51, 51, 0.5);
    padding: 8px 16px;
    cursor: pointer;

    &:hover {
        background: #f7f7f7;
    }
`;
